module.exports = __webpack_public_path__ + "img/horse.81ea4f1c.jpg";